import React from 'react';
import { Tooltip } from 'antd';

interface ToggleTreeButtonProps {
  isFilterHidden: boolean;
  handleHideFilter: () => void;
  isStandby?: boolean;
}
 
function ToggleTreeButton({ isFilterHidden, handleHideFilter, isStandby = false }: ToggleTreeButtonProps) {
  let standbyClass = isStandby ? (isFilterHidden ? 'standby': "hidden") : "";

  return (
      <button
        className={`collapse-filter-btn ${standbyClass}`}
        onClick={handleHideFilter}
      >
        <i className={isFilterHidden ? "icon-right-open-mini" : "icon-left-open-mini"} />
      </button>
  );
}

export default ToggleTreeButton;
